const pastConsultSearchFilterList = {
  patientId: "Patient UIN",
  patientEmail: "Patient Email",
  patientName: "Patient Name",
  doctorId: "Doctor UIN",
  doctorEmail: "Doctor Email",
  doctorName: "Doctor Name",
  appointmentId: "Consult ID",
  deviceDetails: "Device Details"
};

const ticketsSearchFilterList = {
  patientId: "Patient UIN",
  patientName: "Patient Name",
  caseNumber: "Ticket Number",
  subject: "Subject",
};

const unansweredConsultSearchFilterList = {
  patientName: "Patient Name",
  patientEmail: "Patient Email",
  patientId: "Patient UIN",
  deviceDetails: "Device Details"
};

const onlineAssessmentSearchFilterList = {
  appointmentId: "Assessment ID",
  doctorName: "Doctor Name",
  doctorEmail: "Doctor Email",
  doctorId: "Doctor UIN",
  patientName: "Patient Name",
  patientEmail: "Patient Email",
  patientId: "Patient UIN",
};

const traditionalPrescriptionFilterList = {
  patientName: "Patient Name",
  patientEmail: "Patient Email",
  patientId: "Patient UIN",
}

const searchFilterList = {
  pastConsultSearchFilterList,
  unansweredConsultSearchFilterList,
  onlineAssessmentSearchFilterList,
  traditionalPrescriptionFilterList,
  ticketsSearchFilterList
};

export default searchFilterList;
